import { defineI18nConfig } from "#i18n";
export default () => ({ fallbackLocale: "en" });
